<template>
  <div class="widget-inner anim-redesign" @click.stop>
    <div class="anim-shell">
      <div class="anim-header">
        <span class="anim-header__mark" aria-hidden="true">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3v4M12 17v4M3 12h4M17 12h4M6 6l2.6 2.6M15.4 15.4L18 18M6 18l2.6-2.6M15.4 8.6L18 6"></path></svg>
        </span>
        <span class="anim-header__title">Animation</span>
      </div>

      <div class="anim-body">
        <template v-if="activeObject">
        <div class="anim-block">
          <div class="anim-label">Object animation</div>
          <div class="anim-grid anim-grid--4">
            <button type="button" class="anim-tile" :class="{ 'is-on': uiAnimationStyle === 'stomp' }" @click.stop="showSubpanel('stomp', {style: 'stomp', onEnter: true, onExit: false})">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3v11M8 10l4 4 4-4M4 19.5h16"></path></svg>
              <span>Stomp</span>
            </button>
            <button type="button" class="anim-tile" :class="{ 'is-on': uiAnimationStyle == 'panbottom' || uiAnimationStyle == 'pantop' || uiAnimationStyle == 'panleft' || uiAnimationStyle == 'panright' }" @click.stop="showSubpanel('pan', {style: 'panright', onEnter: true, onExit: false})">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M3.5 12h17M7.5 8l-4 4 4 4M16.5 8l4 4-4 4"></path></svg>
              <span>Pan</span>
            </button>
            <button type="button" class="anim-tile" :class="{ 'is-on': uiAnimationStyle == 'fade' }" @click.stop="showSubpanel('fade', {style: 'fade', onEnter: true, onExit: false})">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="8"></circle><path d="M12 4a8 8 0 0 1 0 16z" fill="currentColor" stroke="none"></path></svg>
              <span>Fade</span>
            </button>
            <button type="button" class="anim-tile" :class="{ 'is-on': uiAnimationStyle == 'zoomin' || uiAnimationStyle == 'zoomout' }" @click.stop="showSubpanel('zoom', {style: 'zoomin', onEnter: true, onExit: false})">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><circle cx="10.5" cy="10.5" r="6.5"></circle><path d="M20 20l-4.8-4.8M10.5 7.5v6M7.5 10.5h6"></path></svg>
              <span>Zoom</span>
            </button>
            <button v-if="isActiveObjectIsText" type="button" class="anim-tile" :class="{ 'is-on': uiAnimationStyle == 'typewriter' }" @click.stop="showSubpanel('typewriter', {style: 'typewriter', onEnter: true, onExit: false})">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7V5h11v2M9.5 5v14M7.5 19h4M19 5v14"></path></svg>
              <span>Typewriter</span>
            </button>
            <button v-if="isActiveObjectIsText" type="button" class="anim-tile" :class="{ 'is-on': uiAnimationStyle == 'burst' }" @click.stop="showSubpanel('burst', {style: 'burst', onEnter: true, onExit: false})">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2.5v5M12 16.5v5M2.5 12h5M16.5 12h5M5.3 5.3l3.5 3.5M15.2 15.2l3.5 3.5M5.3 18.7l3.5-3.5M15.2 8.8l3.5-3.5"></path></svg>
              <span>Burst</span>
            </button>
            <button v-if="isActiveObjectIsImage" type="button" class="anim-tile" :class="{ 'is-on': uiAnimationStyle === 'photoZomEnterOut' || uiAnimationStyle === 'photoZomEnterIn' }" @click.stop="showSubpanel('photoZom', {style: 'photoZomEnterOut', onEnter: true, onExit: false})">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><rect x="3.5" y="5" width="13" height="12" rx="2"></rect><path d="M16.5 13l-4-4-9 8M19 3v6M16 6h6"></path></svg>
              <span>Photo zoom</span>
            </button>
            <button v-if="isActiveObjectIsImage" type="button" class="anim-tile" :class="{ 'is-on': uiAnimationStyle === 'photoRiseTop' || uiAnimationStyle == 'photoRiseLeft' || uiAnimationStyle == 'photoRiseRight' || uiAnimationStyle == 'photoRiseBottom' }" @click.stop="showSubpanel('photoRise', {style: 'photoRiseTop', onEnter: true, onExit: false})">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><rect x="5.5" y="4" width="13" height="11" rx="2"></rect><path d="M18.5 12l-4-4-9 7M4 19.5h16M7 17.5l-3 2 3 2M17 17.5l3 2-3 2"></path></svg>
              <span>Photo pan</span>
            </button>
          </div>
        </div>

        <div v-if="activeSubPanel == 'stomp'" class="anim-card">
          <div class="anim-label">Animate</div>
          <div class="anim-seg">
            <button type="button" :class="{ 'is-on': onEnterAnimate && onExitAnimate }" @click.stop="handleAnimation({style: 'stomp', onEnter: true, onExit: true})">Both</button>
            <button type="button" :class="{ 'is-on': onEnterAnimate && !onExitAnimate }" @click.stop="handleAnimation({style: 'stomp', onEnter: true, onExit: false})">On enter</button>
            <button type="button" :class="{ 'is-on': !onEnterAnimate && onExitAnimate }" @click.stop="handleAnimation({style: 'stomp', onEnter: false, onExit: true})">On exit</button>
          </div>
          <div class="anim-slider-row">
            <span class="anim-slider-row__name">Speed</span>
            <input v-model="speed" type="range" class="anim-range" min="1" max="100" aria-label="Speed" :style="{ background: 'linear-gradient(to right, #1570EF 0 ' + (speed || 0) + '%, #D5D9E0 ' + (speed || 0) + '% 100%)' }" @click.stop @mouseup="handleAnimation({style: currentObjAnimeStyle, onEnter: onEnterAnimate, onExit: onExitAnimate})">
            <span class="anim-value">{{ speed }}</span>
          </div>
        </div>

        <div v-if="activeSubPanel == 'pan'" class="anim-card">
          <div class="anim-label">Animate</div>
          <div class="anim-seg">
            <button type="button" :class="{ 'is-on': onEnterAnimate && onExitAnimate }" @click.stop="handleAnimation({style: currentObjAnimeStyle, onEnter: true, onExit: true})">Both</button>
            <button type="button" :class="{ 'is-on': onEnterAnimate && !onExitAnimate }" @click.stop="handleAnimation({style: currentObjAnimeStyle, onEnter: true, onExit: false})">On enter</button>
            <button type="button" :class="{ 'is-on': !onEnterAnimate && onExitAnimate }" @click.stop="handleAnimation({style: currentObjAnimeStyle, onEnter: false, onExit: true})">On exit</button>
          </div>
          <div class="anim-slider-row">
            <span class="anim-slider-row__name">Speed</span>
            <input v-model="speed" type="range" class="anim-range" min="1" max="100" aria-label="Speed" :style="{ background: 'linear-gradient(to right, #1570EF 0 ' + (speed || 0) + '%, #D5D9E0 ' + (speed || 0) + '% 100%)' }" @click.stop @mouseup="handleAnimation({style: currentObjAnimeStyle, onEnter: onEnterAnimate, onExit: onExitAnimate})">
            <span class="anim-value">{{ speed }}</span>
          </div>
          <div class="anim-slider-row">
            <span class="anim-slider-row__name">Distance</span>
            <input v-model="distance" type="range" class="anim-range" min="1" max="100" aria-label="Distance" :style="{ background: 'linear-gradient(to right, #1570EF 0 ' + (distance || 0) + '%, #D5D9E0 ' + (distance || 0) + '% 100%)' }" @click.stop @mouseup="handleAnimation({style: currentObjAnimeStyle, onEnter: onEnterAnimate, onExit: onExitAnimate})">
            <span class="anim-value">{{ distance }}</span>
          </div>
          <div class="anim-label">Direction</div>
          <div class="anim-seg">
            <button type="button" aria-label="From left" :class="{ 'is-on': currentObjAnimeStyle == 'panleft' }" @click.stop="handleAnimation({style: 'panleft', onEnter: onEnterAnimate, onExit: onExitAnimate})"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M11 6l-6 6 6 6"></path></svg></button>
            <button type="button" aria-label="From right" :class="{ 'is-on': currentObjAnimeStyle == 'panright' }" @click.stop="handleAnimation({style: 'panright', onEnter: onEnterAnimate, onExit: onExitAnimate})"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"></path></svg></button>
            <button type="button" aria-label="From top" :class="{ 'is-on': currentObjAnimeStyle == 'pantop' }" @click.stop="handleAnimation({style: 'pantop', onEnter: onEnterAnimate, onExit: onExitAnimate})"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M12 19V5M6 11l6-6 6 6"></path></svg></button>
            <button type="button" aria-label="From bottom" :class="{ 'is-on': currentObjAnimeStyle == 'panbottom' }" @click.stop="handleAnimation({style: 'panbottom', onEnter: onEnterAnimate, onExit: onExitAnimate})"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M12 5v14M6 13l6 6 6-6"></path></svg></button>
          </div>
        </div>

        <div v-if="activeSubPanel == 'fade'" class="anim-card">
          <div class="anim-label">Animate</div>
          <div class="anim-seg">
            <button type="button" :class="{ 'is-on': onEnterAnimate && onExitAnimate }" @click.stop="handleAnimation({style: currentObjAnimeStyle, onEnter: true, onExit: true})">Both</button>
            <button type="button" :class="{ 'is-on': onEnterAnimate && !onExitAnimate }" @click.stop="handleAnimation({style: currentObjAnimeStyle, onEnter: true, onExit: false})">On enter</button>
            <button type="button" :class="{ 'is-on': !onEnterAnimate && onExitAnimate }" @click.stop="handleAnimation({style: currentObjAnimeStyle, onEnter: false, onExit: true})">On exit</button>
          </div>
          <div class="anim-slider-row">
            <span class="anim-slider-row__name">Speed</span>
            <input v-model="speed" type="range" class="anim-range" min="1" max="100" aria-label="Speed" :style="{ background: 'linear-gradient(to right, #1570EF 0 ' + (speed || 0) + '%, #D5D9E0 ' + (speed || 0) + '% 100%)' }" @click.stop @mouseup="handleAnimation({style: currentObjAnimeStyle, onEnter: onEnterAnimate, onExit: onExitAnimate})">
            <span class="anim-value">{{ speed }}</span>
          </div>
        </div>

        <div v-if="activeSubPanel == 'zoom'" class="anim-card">
          <div class="anim-label">Animate</div>
          <div class="anim-seg">
            <button type="button" :class="{ 'is-on': onEnterAnimate && onExitAnimate }" @click.stop="handleAnimation({style: 'zoomin', onEnter: true, onExit: true})">Both</button>
            <button type="button" :class="{ 'is-on': onEnterAnimate && !onExitAnimate }" @click.stop="handleAnimation({style: 'zoomin', onEnter: true, onExit: false})">On enter</button>
            <button type="button" :class="{ 'is-on': !onEnterAnimate && onExitAnimate }" @click.stop="handleAnimation({style: 'zoomin', onEnter: false, onExit: true})">On exit</button>
          </div>
          <div class="anim-slider-row">
            <span class="anim-slider-row__name">Speed</span>
            <input v-model="speed" type="range" class="anim-range" min="1" max="100" aria-label="Scale Speed" :style="{ background: 'linear-gradient(to right, #1570EF 0 ' + (speed || 0) + '%, #D5D9E0 ' + (speed || 0) + '% 100%)' }" @click.stop @mouseup="handleAnimation({style: currentObjAnimeStyle, onEnter: onEnterAnimate, onExit: onExitAnimate})">
            <span class="anim-value">{{ speed }}</span>
          </div>
        </div>

        <div v-if="activeSubPanel == 'typewriter'" class="anim-card">
          <div class="anim-label">Animate</div>
          <div class="anim-seg">
            <button type="button" :class="{ 'is-on': currentObjAnimeStyle == 'typewriter' && onEnterAnimate && onExitAnimate }" @click.stop="handleAnimation({style: 'typewriter', onEnter: true, onExit: true})">Both</button>
            <button type="button" :class="{ 'is-on': currentObjAnimeStyle == 'typewriter' && onEnterAnimate && !onExitAnimate }" @click.stop="handleAnimation({style: 'typewriter', onEnter: true, onExit: false})">On enter</button>
            <button type="button" :class="{ 'is-on': currentObjAnimeStyle == 'typewriter' && !onEnterAnimate && onExitAnimate }" @click.stop="handleAnimation({style: 'typewriter', onEnter: false, onExit: true})">On exit</button>
          </div>
          <div class="anim-slider-row">
            <span class="anim-slider-row__name">Speed</span>
            <input v-model="speed" type="range" class="anim-range" min="1" max="100" aria-label="Speed" :style="{ background: 'linear-gradient(to right, #1570EF 0 ' + (speed || 0) + '%, #D5D9E0 ' + (speed || 0) + '% 100%)' }" @click.stop @mouseup="handleAnimation({style: 'typewriter', onEnter: onEnterAnimate, onExit: onExitAnimate})">
            <span class="anim-value">{{ speed }}</span>
          </div>
        </div>

        <div v-if="activeSubPanel == 'burst'" class="anim-card">
          <div class="anim-label">Animate</div>
          <div class="anim-seg">
            <button type="button" :class="{ 'is-on': currentObjAnimeStyle == 'burst' && onEnterAnimate && onExitAnimate }" @click.stop="handleAnimation({style: 'burst', onEnter: true, onExit: true})">Both</button>
            <button type="button" :class="{ 'is-on': currentObjAnimeStyle == 'burst' && onEnterAnimate && !onExitAnimate }" @click.stop="handleAnimation({style: 'burst', onEnter: true, onExit: false})">On enter</button>
            <button type="button" :class="{ 'is-on': currentObjAnimeStyle == 'burst' && !onEnterAnimate && onExitAnimate }" @click.stop="handleAnimation({style: 'burst', onEnter: false, onExit: true})">On exit</button>
          </div>
          <div class="anim-slider-row">
            <span class="anim-slider-row__name">Speed</span>
            <input v-model="speed" type="range" class="anim-range" min="1" max="100" aria-label="Speed" :style="{ background: 'linear-gradient(to right, #1570EF 0 ' + (speed || 0) + '%, #D5D9E0 ' + (speed || 0) + '% 100%)' }" @click.stop @mouseup="handleAnimation({style: 'burst', onEnter: onEnterAnimate, onExit: onExitAnimate})">
            <span class="anim-value">{{ speed }}</span>
          </div>
        </div>

        <div v-if="activeSubPanel == 'photoZom'" class="anim-card">
          <div class="anim-label">Animate</div>
          <div class="anim-seg">
            <button type="button" :class="{ 'is-on': onEnterAnimate && onExitAnimate }" @click.stop="handleAnimation({style: currentObjAnimeStyle, onEnter: true, onExit: true})">Both</button>
            <button type="button" :class="{ 'is-on': onEnterAnimate && !onExitAnimate }" @click.stop="handleAnimation({style: currentObjAnimeStyle, onEnter: true, onExit: false})">On enter</button>
            <button type="button" :class="{ 'is-on': !onEnterAnimate && onExitAnimate }" @click.stop="handleAnimation({style: currentObjAnimeStyle, onEnter: false, onExit: true})">On exit</button>
          </div>
          <div class="anim-slider-row">
            <span class="anim-slider-row__name">Speed</span>
            <input v-model="speed" type="range" class="anim-range" min="1" max="100" aria-label="Speed" :style="{ background: 'linear-gradient(to right, #1570EF 0 ' + (speed || 0) + '%, #D5D9E0 ' + (speed || 0) + '% 100%)' }" @click.stop @mouseup="handleAnimation({style: currentObjAnimeStyle, onEnter: onEnterAnimate, onExit: onExitAnimate})">
            <span class="anim-value">{{ speed }}</span>
          </div>
          <div class="anim-label">Scale</div>
          <div class="anim-seg">
            <button type="button" :class="{ 'is-on': currentObjAnimeStyle == 'photoZomEnterIn' }" @click.stop="handleAnimation({style: 'photoZomEnterIn', onEnter: onEnterAnimate, onExit: onExitAnimate})">In</button>
            <button type="button" :class="{ 'is-on': currentObjAnimeStyle == 'photoZomEnterOut' }" @click.stop="handleAnimation({style: 'photoZomEnterOut', onEnter: onEnterAnimate, onExit: onExitAnimate})">Out</button>
          </div>
        </div>

        <div v-if="activeSubPanel == 'photoRise'" class="anim-card">
          <div class="anim-label">Animate</div>
          <div class="anim-seg">
            <button type="button" :class="{ 'is-on': onEnterAnimate && onExitAnimate }" @click.stop="handleAnimation({style: currentObjAnimeStyle, onEnter: true, onExit: true})">Both</button>
            <button type="button" :class="{ 'is-on': onEnterAnimate && !onExitAnimate }" @click.stop="handleAnimation({style: currentObjAnimeStyle, onEnter: true, onExit: false})">On enter</button>
            <button type="button" :class="{ 'is-on': !onEnterAnimate && onExitAnimate }" @click.stop="handleAnimation({style: currentObjAnimeStyle, onEnter: false, onExit: true})">On exit</button>
          </div>
          <div class="anim-slider-row">
            <span class="anim-slider-row__name">Speed</span>
            <input v-model="speed" type="range" class="anim-range" min="1" max="100" aria-label="Speed" :style="{ background: 'linear-gradient(to right, #1570EF 0 ' + (speed || 0) + '%, #D5D9E0 ' + (speed || 0) + '% 100%)' }" @click.stop @mouseup="handleAnimation({style: currentObjAnimeStyle, onEnter: onEnterAnimate, onExit: onExitAnimate})">
            <span class="anim-value">{{ speed }}</span>
          </div>
          <div class="anim-label">Direction</div>
          <div class="anim-seg">
            <button type="button" aria-label="From left" :class="{ 'is-on': currentObjAnimeStyle == 'photoRiseLeft' }" @click.stop="handleAnimation({style: 'photoRiseLeft', onEnter: onEnterAnimate, onExit: onExitAnimate})"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M11 6l-6 6 6 6"></path></svg></button>
            <button type="button" aria-label="From right" :class="{ 'is-on': currentObjAnimeStyle == 'photoRiseRight' }" @click.stop="handleAnimation({style: 'photoRiseRight', onEnter: onEnterAnimate, onExit: onExitAnimate})"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"></path></svg></button>
            <button type="button" aria-label="From top" :class="{ 'is-on': currentObjAnimeStyle == 'photoRiseTop' }" @click.stop="handleAnimation({style: 'photoRiseTop', onEnter: onEnterAnimate, onExit: onExitAnimate})"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M12 19V5M6 11l6-6 6 6"></path></svg></button>
            <button type="button" aria-label="From bottom" :class="{ 'is-on': currentObjAnimeStyle == 'photoRiseBottom' }" @click.stop="handleAnimation({style: 'photoRiseBottom', onEnter: onEnterAnimate, onExit: onExitAnimate})"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M12 5v14M6 13l6 6 6-6"></path></svg></button>
          </div>
        </div>

        <div v-show="isActiveObjectHasAnimation" class="remove-container">
          <button type="button" class="remove_animation" @click.stop="removeAnimation">Remove Animation</button>
        </div>

        <div v-if="hasMultiplePages" class="anim-divider"></div>
        </template>

        <template v-if="hasMultiplePages">
        <div class="anim-block">
          <div class="anim-label">Page transition</div>
          <div class="anim-grid anim-grid--3">
            <button type="button" class="anim-page" :class="{ 'is-on': selectedTransition.name == 'transitionNone' }" @click.stop="showPageAnimationSubPanel({style: 'transitionNone'})">
              <span class="anim-page__icon"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="8"></circle><path d="M6.5 17.5l11-11"></path></svg></span>
              <span>None</span>
            </button>
            <button type="button" class="anim-page" :class="{ 'is-on': selectedTransition.name == 'transitionFade' }" @click.stop="showPageAnimationSubPanel({style: 'transitionFade'})">
              <span class="anim-page__icon"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="8"></circle><path d="M12 4a8 8 0 0 1 0 16z" fill="currentColor" stroke="none"></path></svg></span>
              <span>Fade</span>
            </button>
            <button type="button" class="anim-page" :class="{ 'is-on': (selectedTransition.name || '').includes('transitionPan') }" @click.stop="showPageAnimationSubPanel({style: 'transitionPanLeft'})">
              <span class="anim-page__icon"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M3.5 12h17M7.5 8l-4 4 4 4M16.5 8l4 4-4 4"></path></svg></span>
              <span>Pan</span>
            </button>
          </div>
        </div>

        <div v-if="selectedTransition.name == 'transitionFade'" class="anim-card">
          <div class="anim-slider-row">
            <span class="anim-slider-row__name">Duration</span>
            <input v-model="transitionSpeed" type="range" class="anim-range" min="1" max="100" aria-label="Duration" :style="{ background: 'linear-gradient(to right, #1570EF 0 ' + (transitionSpeed || 0) + '%, #D5D9E0 ' + (transitionSpeed || 0) + '% 100%)' }" @click.stop @mouseup="showPageAnimationSubPanel({style: 'transitionFade'})">
            <span class="anim-value">{{ transitionSpeed }}</span>
          </div>
        </div>

        <div v-if="(selectedTransition.name || '').includes('transitionPan')" class="anim-card">
          <div class="anim-slider-row">
            <span class="anim-slider-row__name">Duration</span>
            <input v-model="transitionSpeed" type="range" class="anim-range" min="1" max="100" aria-label="Duration" :style="{ background: 'linear-gradient(to right, #1570EF 0 ' + (transitionSpeed || 0) + '%, #D5D9E0 ' + (transitionSpeed || 0) + '% 100%)' }" @click.stop @mouseup="showPageAnimationSubPanel({style: selectedTransition.name})">
            <span class="anim-value">{{ transitionSpeed }}</span>
          </div>
          <div class="anim-label">Direction</div>
          <div class="anim-seg">
            <button type="button" aria-label="From left" :class="{ 'is-on': selectedTransition.name == 'transitionPanLeft' }" @click.stop="showPageAnimationSubPanel({style: 'transitionPanLeft'})"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M11 6l-6 6 6 6"></path></svg></button>
            <button type="button" aria-label="From right" :class="{ 'is-on': selectedTransition.name == 'transitionPanRight' }" @click.stop="showPageAnimationSubPanel({style: 'transitionPanRight'})"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"></path></svg></button>
            <button type="button" aria-label="From top" :class="{ 'is-on': selectedTransition.name == 'transitionPanTop' }" @click.stop="showPageAnimationSubPanel({style: 'transitionPanTop'})"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M12 19V5M6 11l6-6 6 6"></path></svg></button>
            <button type="button" aria-label="From bottom" :class="{ 'is-on': selectedTransition.name == 'transitionPanBottom' }" @click.stop="showPageAnimationSubPanel({style: 'transitionPanBottom'})"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M12 5v14M6 13l6 6 6-6"></path></svg></button>
          </div>
        </div>
        </template>

        <div v-if="(currentAnimation.style || '').includes('pageZoom')" class="anim-card">
          <div class="anim-label">Animate</div>
          <div class="anim-seg">
            <button type="button" :class="{ 'is-on': onEnterAnimate && onExitAnimate }" @click.stop="updatePageAnimation({style: currentAnimation.style, onEnter: true, onExit: true})">Both</button>
            <button type="button" :class="{ 'is-on': onEnterAnimate && !onExitAnimate }" @click.stop="updatePageAnimation({style: currentAnimation.style, onEnter: true, onExit: false})">On enter</button>
            <button type="button" :class="{ 'is-on': !onEnterAnimate && onExitAnimate }" @click.stop="updatePageAnimation({style: currentAnimation.style, onEnter: false, onExit: true})">On exit</button>
          </div>
          <div class="anim-slider-row">
            <span class="anim-slider-row__name">Speed</span>
            <input v-model="speed" type="range" class="anim-range" min="1" max="100" aria-label="Scale Speed" :style="{ background: 'linear-gradient(to right, #1570EF 0 ' + (speed || 0) + '%, #D5D9E0 ' + (speed || 0) + '% 100%)' }" @click.stop @mouseup="updatePageAnimation({style: currentAnimation.style, onEnter: onEnterAnimate, onExit: onExitAnimate})">
            <span class="anim-value">{{ speed }}</span>
          </div>
          <div class="anim-label">Scale</div>
          <div class="anim-seg">
            <button type="button" :class="{ 'is-on': currentAnimation.style == 'pageZoomIn' }" @click.stop="updatePageAnimation({style: 'pageZoomIn', onEnter: onEnterAnimate, onExit: onExitAnimate})">In</button>
            <button type="button" :class="{ 'is-on': currentAnimation.style == 'pageZoomOut' }" @click.stop="updatePageAnimation({style: 'pageZoomOut', onEnter: onEnterAnimate, onExit: onExitAnimate})">Out</button>
          </div>
        </div>

        <div v-if="hasMultiplePages && currentAnimation.style !== 'pageAnimationNone'" class="remove-container">
          <button type="button" class="remove_animation" @click.stop="removePageTransition">Remove Animation</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from '@/EventBus';
import ApplicationEventTypes from '@/mixins/ApplicationEventTypes';
import ElementAnimationMixin from '@/mixins/ElementAnimation';
import PanelHeading from '@/components/PanelHeading/PanelHeading';
import { forEachCanvasObject, findParentGroup, filterSameTypeAnimationTargets } from '@/components/Canvas/utils/groupHelpers';

export default {
  name:       'AnimationPanel',
  components: {
    'panel-heading': PanelHeading,
  },
  mixins: [ElementAnimationMixin],
  props:  {
    product:             Object,
    activePage:          Number,
    activeObject:        Object,
    selectedObjectsList: {
      type:    Array,
      default: () => [],
    },
  },
  data() {
    return {
      activeSubPanel:    '',
      direction:         '',
      speed:             50,
      transitionSpeed:   50,
      distance:          50,
      onEnterAnimate:    false,
      onExitAnimate:     false,
      selectedAnimation: '',
      bothAnimate:       false,
    };
  },
  computed: {
    currentAnimation() {
      const page = this.product && this.product.pages && this.product.pages[this.activePage];
      return (page && page.animation) || { style: '' };
    },
    togglePageAnimation() {
      return this.$store.getters['activeProduct/getDisplayAnimationPanel'];
    },
    isActiveObjectHasAnimation() {
      const targets = this.getSameTypeAnimationTargets(
        this.activeObject && this.activeObject.animation && this.activeObject.animation.style,
      );
      return targets.some(obj => obj && obj.animation && obj.animation.style
        && String(obj.animation.style).length > 0);
    },
    isActiveObjectIsText() {
      console.log('isActiveObjectIsText');
      console.log(!!((this.activeObject && this.activeObject.type === 'text')));
      return !!((this.activeObject && this.activeObject.type === 'text'));
    },
    isActiveObjectIsImage() {
      return !!((this.activeObject && this.activeObject.type === 'image' && this.activeObject.ImageType != 'SVGImage' && this.activeObject.ImageType != 'FDICLogo' && this.activeObject.ImageType != 'WhiteboxLogo' && this.activeObject.ImageType != 'FDICText'));
    },
    isActiveObjectInGroup() {
      if (!this.activeObject) { return false; }
      if (this.activeObject.type === 'group') { return true; }
      const page = this.product && this.product.pages && this.product.pages[this.activePage];
      if (!page || !page.objectList) { return false; }
      return !!findParentGroup(page.objectList, this.activeObject.Id);
    },
    getPageAnimationIndex() {
      return this.$store.getters['activeProduct/getPageAnimationIndex'];
    },
    hasMultiplePages() {
      const pages = this.product && this.product.pages;
      return !!(pages && pages.length > 1);
    },
    selectedTransition() {
      const index = this.resolveTransitionIndex();
      const transition = this.product.transitions && index >= 0 && this.product.transitions[index];
      if (transition) {
        if (transition.speed != null) {
          this.transitionSpeed = transition.speed;
        }
        return transition;
      }
      return { name: '' };
    },
    uiAnimationStyle() {
      if (this.selectedAnimation) {
        return this.selectedAnimation;
      }
      return this.currentObjAnimeStyle;
    },
    productHasVideoAudioAnimation() {
      let isTrue = false;
      this.product.pages.forEach((page) => {
        forEachCanvasObject(page.objectList, (object) => {
          if (object.type === 'video') {
            isTrue = true;
            return;
          }
          const style = object.animation && object.animation.style != null
            ? String(object.animation.style).trim()
            : '';
          if (style !== '') {
            isTrue = true;
          }
        });
      });
      return isTrue;
    },
    currentObjAnimeStyle() {
      if (this.activeObject) {
        const animation = { ...(this.activeObject.animation || {}) };
        console.log(animation);
        this.speed          = animation.speed;
        this.distance       = animation.distance;
        this.onEnterAnimate = animation.onEnter;
        this.onExitAnimate  = animation.onExit;
        if (animation.style && animation.style.includes('fade')) {
          this.activeSubPanel = 'fade';
        } else if (animation.style && animation.style.includes('zoom')) {
          this.activeSubPanel = 'zoom';
        } else if (animation.style && animation.style.includes('stomp')) {
          this.activeSubPanel = 'stomp';
        } else if (animation.style && animation.style.includes('pan')) {
          this.activeSubPanel = 'pan';
        } else if (animation.style && animation.style.includes('photoZom')) {
          this.activeSubPanel = 'photoZom';
        } else if (animation.style && animation.style.includes('photoRise')) {
          this.activeSubPanel = 'photoRise';
        } else if (animation.style && animation.style.includes('typewriter')) {
          this.activeSubPanel = 'typewriter';
        } else if (animation.style && animation.style.includes('burst')) {
          this.activeSubPanel = 'burst';
        } else {
          this.activeSubPanel = '';
        }
        return animation.style;
      }
      return '';
    },
  },
  mounted() {
    this.onEnterAnimate = this.product.pages[this.activePage].animation.onEnter;
    this.onExitAnimate  = this.product.pages[this.activePage].animation.onExit;
    this.speed          = this.product.pages[this.activePage].animation.speed;
    if (this.activeObject) {
      this.onEnterAnimate = this.activeObject.animation && this.activeObject.animation.onEnter ? this.activeObject.animation.onEnter : false;
      this.onExitAnimate  = this.activeObject.animation && this.activeObject.animation.onExit ? this.activeObject.animation.onExit : false;
      this.speed          = this.activeObject.animation && this.activeObject.animation.speed ? this.activeObject.animation.speed : 1;
    }
  },
  methods: {
    resolveTransitionIndex() {
      const pages   = (this.product && this.product.pages) || [];
      const lastGap = pages.length - 2;
      if (lastGap < 0) {
        return -1;
      }
      const openedFromGap = !this.activeObject && this.$store.getters['activeProduct/getPageAnimationPanel'];
      const stored        = this.$store.getters['activeProduct/getPageAnimationIndex'];
      if (openedFromGap && stored >= 0 && stored <= lastGap) {
        return stored;
      }
      const page = Number(this.activePage);
      if (page >= 0 && page <= lastGap) {
        return page;
      }
      if (page > lastGap) {
        return lastGap;
      }
      return 0;
    },
    removePageTransition() {
      this.showPageAnimationSubPanel({ style: 'transitionNone' });
    },
    showPageAnimationSubPanel({ style }) {
      const pageIndex = this.resolveTransitionIndex();
      const page      = this.product && this.product.pages && this.product.pages[pageIndex];
      const nextPage  = this.product && this.product.pages && this.product.pages[pageIndex + 1];
      if (pageIndex < 0 || !page || !nextPage || style == '') {
        return;
      }
      this.$store.commit('activeProduct/updatePageAnimationIndex', pageIndex);
      const firstScreenStartTime  = this.calculateFirstScreenStartTime(pageIndex);
      const secondScreenStartTime = this.calculateSecondScreenTime(pageIndex);
      const firstScreenDuration   = this.calculateScreenDuration(pageIndex);
      const secondScreenDuration  = this.calculateScreenDuration(pageIndex + 1);
      const transition            = [
        {
          name:  style,
          speed: this.transitionSpeed,
          pageIndex,
          firstScreenStartTime,
          firstScreenDuration,
          secondScreenStartTime,
          secondScreenDuration,
        }];
      this.updateTransition(transition);
      this.updatePageAnimation({ style, index: pageIndex, speed: this.transitionSpeed });
      setTimeout(() => { EventBus.$emit(ApplicationEventTypes.TransitionEvents.PREVIEW_TRANSITION, transition); });
    },
    pageDurationAt(index) {
      const page     = this.product && this.product.pages && this.product.pages[index];
      const duration = page && page.animation ? parseFloat(page.animation.duration) : 5;
      return Number.isNaN(duration) ? 5 : duration;
    },
    calculateFirstScreenStartTime(index) {
      let startTime = 0;
      for (let i = 0; i < index; i++) {
        startTime += this.pageDurationAt(i);
      }
      return startTime;
    },
    calculateSecondScreenTime(index) {
      let startTime = 0;
      for (let i = 0; i <= index; i++) {
        startTime += this.pageDurationAt(i);
      }
      return startTime;
    },
    calculateScreenDuration(index) {
      return this.pageDurationAt(index);
    },
    updateTransition(transition) {
      EventBus.$emit(ApplicationEventTypes.TransitionEvents.UPDATE_TRANSITION, transition);
    },
    updatePageAnimation({ style, onEnter, onExit, index, speed }) {
      const appliedSpeed = speed != null ? speed : this.speed;
      if (onEnter !== undefined) {
        this.onEnterAnimate = onEnter;
      }
      if (onExit !== undefined) {
        this.onExitAnimate = onExit;
      }
      const pageIndex     = index != null ? index : this.activePage;
      EventBus.$emit(ApplicationEventTypes.TransitionEvents.ADD_TRANSITION, style, pageIndex, appliedSpeed);
      this.emitUndoRedoRequest('Apply Transition');
      setTimeout(() => {
        // this.pageTransition({
        //   speed, style, onEnter, onExit,
        // });
      }, 50);
    },
    handleAnimation({ style, onEnter, onExit }) {
      const { speed }        = this;
      const { distance }     = this;
      const duration         = this.product.pages[this.activePage].animation.duration;
      this.onEnterAnimate    = onEnter;
      this.selectedAnimation = style;
      this.onExitAnimate     = onExit;
      const objects          = this.getSameTypeAnimationTargets(style);
      EventBus.$emit(ApplicationEventTypes.AnimationEvent.SET_ELEMENT_ANIMATION, {
        animation: {
          speed,
          style,
          onEnter,
          onExit,
          distance,
        },
        isAnimated:      true,
        primaryObjectId: this.activeObject && this.activeObject.Id,
      });
      this.animateElement({
        speed, style, onEnter, onExit, duration, distance, objects,
      });
      if (objects.length > 1 || this.isActiveObjectInGroup) {
        EventBus.$emit(ApplicationEventTypes.Canvas.HIDE_BOUNDING_BOX, true);
      }
      this.emitUndoRedoRequest('apply Animation');
    },
    showSubpanel(styleName, { style, onEnter, onExit }) {
      this.speed          = 50;
      this.distance       = 50;
      this.onEnterAnimate = onEnter;
      this.onExitAnimate  = onExit;
      this.activeSubPanel = styleName;
      console.log('showSubpanel this.distance');
      console.log(this.distance);
      if (style != '') {
        this.handleAnimation({
          speed:    this.speed, style, onEnter, onExit, distance: this.distance,
        });
      }
    },
    removeAnimation() {
      const style    = '';
      const speed    = 50;
      const distance = 50;
      const onEnter  = false;
      const onExit   = false;

      EventBus.$emit(ApplicationEventTypes.AnimationEvent.SET_ELEMENT_ANIMATION, {
        animation: {
          speed,
          style,
          onEnter,
          onExit,
          distance,
        },
        isAnimated:      false,
        primaryObjectId: this.activeObject && this.activeObject.Id,
      });
    },
    getSameTypeAnimationTargets(style) {
      if (this.activeObject && this.activeObject.type === 'group') {
        return [];
      }
      const objects = (this.selectedObjectsList && this.selectedObjectsList.length)
        ? this.selectedObjectsList
        : (this.activeObject ? [this.activeObject] : []);
      const targets = filterSameTypeAnimationTargets(objects, this.activeObject, style);
      if (targets.length) {
        return targets;
      }
      return this.activeObject && this.activeObject.type !== 'group' ? [this.activeObject] : [];
    },
    emitUndoRedoRequest(data) {
      EventBus.$emit('addIntoPageWiseUndoRedoArray', data);
    },
  },
};
</script>

<style scoped lang="scss">
.anim-redesign {
  padding: 0;
  color: #14161b;
}

.anim-shell {
  background: #fbfbfc;
}

.anim-header {
  display: flex;
  align-items: center;
  gap: 10px;
  height: 52px;
  padding: 0 16px;
  border-bottom: 1px solid #e7e9ed;
}

.anim-header__mark {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: #1570ef;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.anim-header__title {
  font-size: 15px;
  font-weight: 650;
}

.anim-body {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 16px 16px 24px;
}

.anim-block,
.anim-card {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.anim-card {
  gap: 10px;
  padding: 12px;
  background: #f3f4f6;
  border-radius: 10px;
}

.anim-label {
  font-size: 11.5px;
  font-weight: 600;
  color: #5e6573;
}

.anim-grid {
  display: grid;
  gap: 6px;
}

.anim-grid--4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.anim-grid--3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.anim-tile,
.anim-page,
.anim-seg button {
  border: 0;
  cursor: pointer;
  font-family: inherit;
  color: #3d4350;
  background: #f3f4f6;
}

.anim-tile {
  height: 54px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  border-radius: 10px;
  padding: 0 2px;
}

.anim-tile span {
  font-size: 10.5px;
  font-weight: 500;
  white-space: nowrap;
}

.anim-tile.is-on {
  background: #eaf2fe;
  color: #0b57c2;
  box-shadow: inset 0 0 0 1.5px #1570ef;
}

.anim-seg {
  display: flex;
  gap: 2px;
  padding: 3px;
  background: #fbfbfc;
  border-radius: 10px;
}

.anim-seg button {
  flex: 1 1 0;
  height: 26px;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 7px;
  padding: 0 6px;
  background: transparent;
  font-size: 12.5px;
  font-weight: 500;
}

.anim-seg button.is-on {
  background: #ffffff;
  color: #0b57c2;
  font-weight: 600;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.1), 0 0 0 1px #e7e9ed;
}

.anim-seg button.is-on svg {
  color: #0b57c2;
  stroke: currentColor;
}

.anim-slider-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.anim-slider-row__name {
  width: 64px;
  flex-shrink: 0;
  font-size: 12.5px;
  color: #3d4350;
}

.anim-range {
  -webkit-appearance: none;
  appearance: none;
  flex: 1 1 auto;
  min-width: 0;
  height: 4px;
  border-radius: 2px;
  outline: none;
  margin: 0;
  padding: 0;
}

.anim-range::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 0 0 1px rgba(16, 24, 40, 0.18), 0 1px 3px rgba(16, 24, 40, 0.25);
  cursor: pointer;
}

.anim-range::-moz-range-thumb {
  width: 14px;
  height: 14px;
  border: 0;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 0 0 1px rgba(16, 24, 40, 0.18), 0 1px 3px rgba(16, 24, 40, 0.25);
  cursor: pointer;
}

.anim-value {
  width: 44px;
  height: 26px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fbfbfc;
  border-radius: 6px;
  font-size: 12px;
  color: #14161b;
}

.anim-divider {
  height: 1px;
  background: #e7e9ed;
}

.anim-page {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 6px;
  padding: 5px 5px 7px;
  border-radius: 10px;
  background: #ffffff;
  box-shadow: inset 0 0 0 1px #e7e9ed;
  font-size: 11.5px;
  font-weight: 500;
}

.anim-page__icon {
  height: 38px;
  border-radius: 7px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f3f4f6;
  color: #3d4350;
}

.anim-page.is-on {
  background: #eaf2fe;
  color: #0b57c2;
  font-weight: 600;
  box-shadow: inset 0 0 0 1.5px #1570ef;
}

.anim-page.is-on svg {
  color: #0b57c2;
  stroke: currentColor;
}

.anim-page.is-on .anim-page__icon {
  background: #ffffff;
}

.remove-container {
  margin-top: 0;
}
</style>
